export const ACTION_TYPES = {
    CREATE_A_POST: "CREATE_A_POST", 
    SEARCH_ACTION: "SEARCH_ACTION", 
    INITIALIZE: "INITIALIZE", 
    LIKE_A_POST: "LIKE_A_POST",
    DISLIKE_A_POST: "DISLIKE_A_POST",
    BOOKMARK: "BOOKMARK", 
    REMOVE_BOOKMARK: "REMOVE_BOOKMARK", 
    DOWNLOADED_BOOKMARK: "DOWNLOADED_BOOKMARK", 
    USERS: "USERS", 
    FOLLOW_USER: "FOLLOW_USER", 
    UPDATE_AUTHENTICATED_USER: "UPDATE_AUTHENTICATED_USER", 
    TO_FOLLOW: "TO_FOLLOW", 
    USER_DETAILS: "USER_DETAILS", 
    POST_DETAILS: "POST_DETAILS", 
    USERS_POST: "USERS_POST"
}